'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Header from '@/components/layout/Header';
import HomepageHero from '@/app/components/HomepageHero';
import KBSectionGrid from '@/app/components/KBSectionGrid';
import MaterialsHub from '@/app/components/MaterialsHub';
import RecentArticles from '@/app/components/RecentArticles';
import { useAuth } from '@/context/AuthContext';
import { useEffect } from 'react';

export default function HomePage() {
  const { isAuthenticated } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!isAuthenticated) router?.push('/login');
  }, [isAuthenticated, router]);

  if (!isAuthenticated) return null;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-8 space-y-16">
        <HomepageHero />
        <KBSectionGrid />
        <MaterialsHub />
        <RecentArticles />
      </main>
      <footer className="border-t border-border mt-16">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="font-serif text-gold font-semibold">SilkCards</span>
            <span className="text-muted-foreground text-xs">Internal Knowledge Base</span>
          </div>
          <p className="text-xs text-muted-foreground">Last system update: Sep 6, 2026 · For internal use only</p>
        </div>
      </footer>
    </div>
  );
}